/* tslint:disable */
/* eslint-disable */
/**
 * Navitia API - SNCF
 * Complete API documentation for Navitia/SNCF public transportation API. Based on https://doc.navitia.io
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '@/client/configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '@/client/common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '@/client/base';
// @ts-ignore
import type { Coverage } from '@/client/models';
// @ts-ignore
import type { CoverageResponse } from '@/client/models';
/**
 * CoverageApi - axios parameter creator
 */
export const CoverageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get coverage area details
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageGet: async (coverage: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageGet', 'coverage', coverage)
            const localVarPath = `/coverage/{coverage}`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all available coverage areas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/coverage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CoverageApi - functional programming interface
 */
export const CoverageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CoverageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get coverage area details
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageGet(coverage: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Coverage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageGet(coverage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CoverageApi.coverageCoverageGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all available coverage areas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoverageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CoverageApi.coverageGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CoverageApi - factory interface
 */
export const CoverageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CoverageApiFp(configuration)
    return {
        /**
         * 
         * @summary Get coverage area details
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageGet(coverage: string, options?: RawAxiosRequestConfig): AxiosPromise<Coverage> {
            return localVarFp.coverageCoverageGet(coverage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all available coverage areas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageGet(options?: RawAxiosRequestConfig): AxiosPromise<CoverageResponse> {
            return localVarFp.coverageGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CoverageApi - interface
 */
export interface CoverageApiInterface {
    /**
     * 
     * @summary Get coverage area details
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageGet(coverage: string, options?: RawAxiosRequestConfig): AxiosPromise<Coverage>;

    /**
     * 
     * @summary List all available coverage areas
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageGet(options?: RawAxiosRequestConfig): AxiosPromise<CoverageResponse>;

}

/**
 * CoverageApi - object-oriented interface
 */
export class CoverageApi extends BaseAPI implements CoverageApiInterface {
    /**
     * 
     * @summary Get coverage area details
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageGet(coverage: string, options?: RawAxiosRequestConfig) {
        return CoverageApiFp(this.configuration).coverageCoverageGet(coverage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all available coverage areas
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageGet(options?: RawAxiosRequestConfig) {
        return CoverageApiFp(this.configuration).coverageGet(options).then((request) => request(this.axios, this.basePath));
    }
}

